import {
  AsyncComponent,
  ErrorBoundary,
  Loading
} from '@splunk-iteng/splunk-shared-components'
import React, { Suspense } from 'react'
import { useOktaUserQuery } from '../../generated/generated'

export function SharedLevel() {
  return (
    <ErrorBoundary fallback={<div>Error Message...</div>}>
      <Suspense fallback={<Loading />}>
        <AsyncComponent
          hook={useOktaUserQuery}
          hookPayload={{ username: 'jgomezhernandez' }}
        />
      </Suspense>
    </ErrorBoundary>
  )
}
